import axios from 'axios';

const getAuthHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

export const listPrompts = async ({ projectPid }) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/api/v1/prompts/list`,
    { projectPid },
    { headers: getAuthHeader() },
  );
  return response.data;
};

export const getPromptByType = async ({ projectPid, promptType }) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/api/v1/prompts/get-by-type`,
    { projectPid, promptType },
    { headers: getAuthHeader() },
  );
  return response.data;
};

export const getPrompt = async ({ projectPid, promptPid }) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/api/v1/prompts/get`,
    { projectPid, promptPid },
    { headers: getAuthHeader() },
  );
  return response.data;
};

export const createPrompt = async ({ projectPid, promptType, content, temperature }) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/api/v1/prompts/create`,
    { projectPid, promptType, content, ...(temperature !== undefined ? { temperature } : {}) },
    { headers: getAuthHeader() },
  );
  return response.data;
};

export const updatePrompt = async ({ prompt_pid, content, temperature }) => {
  const response = await axios.put(
    `${process.env.REACT_APP_BASE_URL}/api/v1/prompts/update`,
    { promptPid: prompt_pid, content, ...(temperature !== undefined ? { temperature } : {}) },
    { headers: getAuthHeader() },
  );
  return response.data;
};
